import { React, useEffect, useState, useContext } from "react";
import { MyContextProvider } from "../../../../../App";
import axios from "axios";
import { API_URL, getAuthHeaders, getUserClaimsForUi } from "../../../../../Constant";
import { GlobalLoading, showLoading } from "react-global-loading";
import { handleUserLevelAccessPermissions, validateRolesIIPHQ, shortMonthToFull } from "../../../../../Custom/Custom";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { IIPMajorGroupIndexReport } from "../../ExportIIPExcel";
import iipTitleData from '../../../../../iip.json';
import iipFieldTitleData from '../../../../../titles.json';
import messages from '../../.././../../assets/Messages.json';

const MajorGroupIndexReport = () => {
    const [years, setYears] = useState([]);
    const [yearName, setYearName] = useState("");

    const [months, setMonths] = useState([]);



    const [monthName, setMonthName] = useState("");


    // const [indexReport, setIndexReportList] = useState([]);
    // const [repeatDataListForQ, setRepeatDataListForQ] = useState([]);
    // const [repeatDataListForP, setRepeatDataListForP] = useState([]);

    const [buttonAccess, setButtonAccess] = useState({
        userLevel: "",
        roles: "",
        isVisible: false,
    });

    const token = useContext(MyContextProvider).token;



    const decode_token = getUserClaimsForUi();
    const navigate = useNavigate();
    const config = getAuthHeaders();


    const storedLanguage = localStorage.getItem('language');



    const getAllYears = () => {
        const currentYear = new Date().getFullYear();
        const yearsArray = [];
        for (let year = currentYear; year >= 2021; year--) {
            yearsArray.push(year);
        }
        return yearsArray;
    };

    const getMonthsList = () => {
        showLoading(true);
        axios
            .get(`${API_URL}api/graph/getMonths/2019`, config)
            .then((res) => {
                let monthDataResponse = res.data;
                console.warn("PPPPPPPPP", monthDataResponse);

                if (monthDataResponse.status) {
                    const monthList = monthDataResponse.data.map(item => item.MONTH);
                    setMonths(monthList);

                }
            })
            .catch((err) => {
                console.error(err);
            })
            .finally(() => {
                showLoading(false);
            });
    };



    useEffect(() => {
        const level = handleUserLevelAccessPermissions(decode_token);
        const getYearList = () => {
            setYears(getAllYears());
        };

        const userRole = async () => {
            showLoading(true);
            try {
                const role = await validateRolesIIPHQ(decode_token);
                if (role) {
                    getYearList();
                    getMonthsList(); 

                } else {
                    alert(
                        "You are not an authorized for IIP Report."
                    );
                    navigate("/dashboard");
                }
            } catch (error) {
                console.log(error);
                showLoading(false);
            } finally {
                showLoading(false);
            }
        };

        userRole();
    }, []);

    const handleYearChange = (e) => {
        setYearName(e.target.value);
    };

    const handleMonthChange = (e) => {
        setMonthName(e.target.value);
    };

    const handleGenerateExcel = async () => {
        if (!yearName) {
            toast.error("Please select a Survey Year", messages.COLOR_RED);
            return;
        }

        showLoading(true);
        try {
            const postData = { year: yearName, month: monthName };
            const response = await axios.post(`${API_URL}api/iipReports/HQreports/MajorGroupIndexReport`, postData, config);
            const allData = response.data.report;

             if (allData) {
       
                downloadReport(allData,yearName,monthName);
          } else {
                console.warn('No data in API response');
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            showLoading(false);
        }
    };



    const getMonthNames = (selectedMonth) => {
        const months = [
            'JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 
            'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'
        ];
    
        const currentMonthIndex = months.indexOf(selectedMonth);
        const prevMonthIndex = (currentMonthIndex - 1 + 12) % 12;
        const twoMonthsPriorIndex = (currentMonthIndex - 2 + 12) % 12;
    
        return {
            current: months[currentMonthIndex],
            previous: months[prevMonthIndex],
            twoMonthsPrior: months[twoMonthsPriorIndex],
            year: currentMonthIndex === 0 ? yearName - 1 : yearName,
            prevYear: currentMonthIndex <= 1 ? yearName - 1 : yearName
        };
    };

const downloadReport=(allData,yearName,monthName)=>{

    const { current, previous, twoMonthsPrior, year, prevYear } = getMonthNames(monthName);
    let indexReport=allData.IndexReportList || [];
    let repeatDataListForQ=allData.RepeatDataListForQ || [];
    let repeatDataListForP=allData.RepeatDataListForP || [];

    const excelObjectData = [
        {

            reportType: 'MajorGIReport',
            fileType: 'xls',
            sheetName: "Page1",
            firstRowMergeCells: "A1:E1",
            firstRowExportData: 'COMPUTATION OF INDUSTRIAL PRODUCTION INDEX  U.P',
            firstRowCellNumber: 4,
            secondRowMergeCells: "A2:E2",
            secondRowText: 'Major Industrywise Index',
            thirdRowMergeCells: "A3:E3",
            thirdRowText: `Base Year(2011-12)`,
            fourthRowMergeCells: "A4:E4",
            fourthRowText: `(${monthName}-${yearName})`,
            headerEnglishColumns: [
               'NIC 2D', `${monthName}-${yearName}`, `${previous}-${year}(Q)`, `${twoMonthsPrior}-${year}(P)`, `${monthName}-${parseInt(yearName) - 1}(F)`
            ],
            excelRowData: indexReport.map(item => [
                item.nic2d,
                item.index,
                item.index_wt2,
                item.index3,
                item.index4
            ]),
        },
        {

            reportType: 'MajorGIReport',
            fileType: 'xls',
            sheetName: "Page2",
            firstRowExportData: 'Repeat Data for Q month ' + (monthName || 'N/A'),
            headerEnglishColumns: [
                'Division Code', 'District Code', 'Industry Code', 'NIC 5D', 'Item Code', 'Item Name',
                'Total Man Days of Workers', 'Total Manufacturing', 'Units', 'Quantity', 'Value',
                'Month Production', 'Industry Status', 'Index', 'Index Weight', 'Weight', 'Base Productivity'
            ],
            excelRowData: repeatDataListForQ.map(item => [
                item.divisionCode,
                item.districtCode,
                item.industryCode,
                item.nic2d,
                item.nic2d,
                item.item_name,
                item.totalmanufectring,
                item.mandayworker,
                item.unit_name,
                item.quantity,
                item.value,
                item.month_production,
                item.industry_status,
                item.index,
                item.index_wt,
                item.weight,
                item.bp
            ]),
        },
        {

            reportType: 'MajorGIReport',
            fileType: 'xls',
            sheetName: "Page3",
            firstRowExportData: 'Repeat Data for P month ' + (monthName || 'N/A'),
            headerEnglishColumns: [
                'Division Code', 'District Code', 'Industry Code', 'NIC 5D', 'Item Code', 'Item Name',
                'Total Man Days of Workers', 'Total Manufacturing', 'Units', 'Quantity', 'Value',
                'Month Production', 'Industry Status', 'Index', 'Index Weight', 'Weight', 'Base Productivity'
            ],
            excelRowData: repeatDataListForP.map(item => [
                item.divisionCode,
                item.districtCode,
                item.industryCode,
                item.nic2d,
                item.nic2d,
                item.item_name,
                item.mandayworker,
                item.totalmanufectring,
                item.unit_name,
                item.quantity,
                item.value,
                item.month_production,
                item.industry_status === 1 ? 'Close' : 'Open',
                item.index,
                item.index_wt,
                item.weight,
                item.bp
            ]),
        }
    ];

    // Create the Excel file with multiple sheets
    let finalObject = {
        excelObjectData: excelObjectData,
        fileName: `MajorgroupIndexReport_${monthName}-${yearName}`,
        fileType: 'xls'
    }
    IIPMajorGroupIndexReport(finalObject); // Modify this function to handle multiple sheets if necessary


    }


    return (
        <>
            <GlobalLoading />
            <ToastContainer />
            <div className="container-fluid py-3">
                <div className="card mx-3 mb-3">
                    <div className="card-body pb-1">
                        <div className="row align-items-center">
                            <h4 className="page_heading">
                                <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? iipTitleData.hi.MAJOR_GROUP_INDEX_REPORT : iipTitleData.en.MAJOR_GROUP_INDEX_REPORT }} />
                            </h4>

                            <div className="row align-items-center">
                                <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                                    <label className="fw-bold h6">
                                        Month</label>
                                    <select
                                        name="year_name"
                                        className="form-select"
                                        onChange={handleMonthChange}
                                        value={monthName}
                                    >
                                        <option value="" disabled>
                                            Select Month
                                        </option>
                                        {months &&
                                            months.map((ele, index) => (
                                                <option key={index} value={ele}>
                                                    {shortMonthToFull(ele)}
                                                </option>
                                            ))}
                                    </select>
                                </div>

                                <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                                    <label className="fw-bold h6">
                                        {storedLanguage === 'hi' ? iipFieldTitleData.hi.YEAR : iipFieldTitleData.en.YEAR}</label>
                                    <select
                                        name="year_name"
                                        className="form-select"
                                        onChange={handleYearChange}
                                        value={yearName}
                                    >
                                        <option value="" disabled>
                                            Select Year
                                        </option>
                                        {years &&
                                            years.map((ele, index) => (
                                                <option key={index} value={ele}>
                                                    {ele}
                                                </option>
                                            ))}
                                    </select>
                                </div>

                                <div className="col-xl-2 col-lg-12 mb-3">
                                    <label className="w-100 d-none d-sm-block">&nbsp;</label>
                                    <button onClick={handleGenerateExcel} className="btn btn_orange">Generate Report</button>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </>
    )
}

export default MajorGroupIndexReport